import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import SelectDateRange from "../components/common/selectDateRange";
import Select from "./common/select";
import moment from "moment";

const OperationsModal = ({
  displayModal,
  disabled,
  handleClose,
  data,
  types,
  openType,
  handleChange,
  handleFromChange,
  handleToChange,
  handleSubmit
}) => {
  const now = moment().format("YYYY-MM-DD");
  const start = data["startDate"] ? data["startDate"].format("YYYY-MM-DD") : now;
  const end = data["endDate"] ? data["endDate"].format("YYYY-MM-DD") : now;
  
  return (
    <Modal show={displayModal} onHide={handleClose}>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>
          {openType === "New" ? "New Operation" : "Update Operation"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row">
            <div className="col">
              <Select
                name="type"
                label="Operation Type"
                placeholder="Select Type"
                value={data.type}
                options={types}
                error=""
                onChange={handleChange}
                disabled={disabled}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <SelectDateRange
                label="Date Range"
                // labelFrom="From"
                // labelTo="To"
                value={start}
                value2={end}
                onFromChange={handleFromChange}
                onToChange={handleToChange}
                disabled={disabled}
                disabled2={false}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-primary"
          onClick={() => handleSubmit(openType)}
        >
          {openType === "New" ? "Create" : "Update"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default OperationsModal;
